import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RestapiService {

  public USER_NAME_ATTRIBUTE_NAME = 'authenticatedUser';
  public PASSWORD_ATTRIBUTE_NAME = 'authenticatedUserPass';
  message: any;
  public showloader = false;

  username;
  password;

  constructor(private http: HttpClient) {
  }

  public login(username: string, password: string): Observable<any> {
    this.username = username;
    this.password = password;
    const headers = new HttpHeaders({Authorization: 'Basic ' + btoa(username + ':' + password), });
    return this.http.get('https://jakuwegiel-backend.herokuapp.com/', {headers, responseType: 'text' as 'json'});
  }

  public getUsersInfo(username: string, password: string): Observable<any> {
    console.log('username ' + username);
    const headers = new HttpHeaders({Authorization: 'Basic ' + btoa(username + ':' + password)});
    return this.http.get('https://jakuwegiel-backend.herokuapp.com/getUsersInfo', {headers});
  }

  public postResetPassword(token: string, password: string): Observable<any> {
    const body = {
      'token': token,
      'password': password
    };
    const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<any>('https://endlessblow-1.herokuapp.com/reset_password', body,{headers: headers});
  }



  public logout(): void {
    this.username = '';
    this.password = '';
    // remove user from local storage and set current user to null
    localStorage.removeItem(this.USER_NAME_ATTRIBUTE_NAME);
    localStorage.removeItem(this.PASSWORD_ATTRIBUTE_NAME);
  }

  public isLogged(): boolean {
    return localStorage.getItem(this.USER_NAME_ATTRIBUTE_NAME) !== null;
  }
}
